import { InspectorControls } from '@wordpress/block-editor';
import { PanelBody, TextControl, Notice } from '@wordpress/components';
import { t } from "drupal";
import { useState, useEffect, useCallback } from "@wordpress/element";
import { handleUrlChange2, sanitizeInput, sanitizeKeepHTML, isValidDomain } from '../utilities/helpers';

function SidePanel({

    linkUrl = '',
    linkText = '',
    ariaLabel = '',
    linkTextError = "",
    linkUrlError = "",
    setAttributes
}) {

  const [errors, setErrors] = useState({});


  const onChangeAriaLabel = (value) => setAttributes({ ariaLabel: value });

  /**
  * If the user presses Enter or Tab, update the URL
  **/

  const handleKeyDown = useCallback((event) => {
    if ((event.key === 'Enter' || event.key === 'Tab') && linkUrl) {
      //handleUrlChange2 is from /deohs_gutenberg_blocks/blocks/utilities/helpers.js
      const updatedUrl = handleUrlChange2(linkUrl);
      if (updatedUrl !== linkUrl) { // Prevent unnecessary updates
        setAttributes({ linkUrl: updatedUrl });
      }
    }
  }, [linkUrl, setAttributes]);


  /* Strip out HTML and script for CTA. Limit characters to 70 because
     too many chars will appear outside the image backed card
  */
  const onChangeLinkText = (value) => {
    const cleanedText = sanitizeInput(value);
    const limitedText = cleanedText.slice(0, 70); // max 70 chars
    setAttributes({ linkText: limitedText });
  };

  // Strip out HTML and script for title
  const onChangeLink = (value) => {
    const cleanedText = sanitizeInput(value);
    setAttributes({ linkUrl: cleanedText });
  };



  /*
  * For the notice alert of side panel, it muse use useEffect instead of validation.js
  */
  useEffect(() => {
    setErrors({
      linkUrl: !isValidDomain(linkUrl),
      linkText: !linkText.trim() || linkText.trim().length > 70,
    });
  }, [linkUrl, linkText]);




  return (
    <InspectorControls>
      <PanelBody title={t("Instructions")} initialOpen>
        {/* Text Content */}

        <p>To add an image, click on the purple placeholder image of the card
        </p><br />

        </PanelBody>

      <PanelBody title={t("Form")} initialOpen>

      {errors.linkUrl && <Notice status="error">{t("Valid link URL is required")}</Notice>}
        <TextControl
          label={t("Card Link URL")}
          value={linkUrl}
          onChange={onChangeLink}
          className={`${linkUrlError ? "editor-field-error is-required" : ""}`}
          onBlur={() => {
            if (linkUrl) { // Prevent running on empty string
              const updatedUrl = handleUrlChange2(linkUrl);
              if (updatedUrl !== linkUrl) {
                setAttributes({ linkUrl: updatedUrl });
              }
            }

          }}
          onKeyDown={handleKeyDown} // Uses useCallback for efficiency
          placeholder={t("/about or example.com")}
        />

      {errors.linkText && <Notice status="error">{t("Link Text is required and under 70 chars max")}</Notice>}
      <TextControl
        label="Link Text"
        value={linkText}
        className={`${linkTextError ? "editor-field-error is-required" : ""}`}
        placeholder={t("Learn more (70 chars max)")}
        onChange={(value) => {
            onChangeLinkText(value); // this includes the slice(0, 70)
            setErrors((prev) => ({ ...prev, linkText: !value.trim() }));
          }}
      />
      </PanelBody>
      <PanelBody title="Accessibility Settings">
        <TextControl
          label="Aria Label"
          value={ariaLabel || ""}
          onChange={onChangeAriaLabel}
          help="If you are using a generic phrase for your link text like learn more add text here so people on screen readers know where the link actually goes."
        />
      </PanelBody>
    </InspectorControls>
  );
}

export default SidePanel;
